import logger from '@/lib/logger'

/**
 * Hashes email prefix with SHA-256 for privacy-preserving analytics.
 * Returns `<hashed_prefix>@<domain>` or null if unavailable.
 */
export async function hashEmailForAnalytics(email: string | undefined | null): Promise<string | null> {
  if (!email) return null

  email = email.trim().toLowerCase()

  // Check if crypto.subtle is available (browser, HTTPS/localhost only)
  if (typeof crypto === 'undefined' || !crypto.subtle) {
    logger.warn('crypto.subtle unavailable for email hashing')
    return null
  }

  try {
    const encoder = new TextEncoder()
    const hashBuffer = await crypto.subtle.digest('SHA-256', encoder.encode(email))
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  } catch (error) {
    logger.error(error, 'Failed to hash email for analytics')
    return null
  }
}
